<template>
    <v-app>
        <Navbar />
        <v-main :style="{ background: $vuetify.theme.current.colors.border }">
            <v-overlay v-model="showProgressLogin" opacity="1">
                <v-progress-circular indeterminate size="100">
                    Logging in...
                </v-progress-circular>
            </v-overlay>
            <v-container
                fill-height
                fluid
                class="d-flex flex-column align-start align-content-start"
                :style="{
                    background: $vuetify.theme.current.colors.typography3,
                }"
            >
                <div v-if="alertInfo">
                    <v-alert
                        class="ma-0"
                        type="info"
                        variant="outlined"
                        color="secondary"
                        closable
                        @click:close="alertInfo = ''"
                    >
                        {{ alertInfo }}
                    </v-alert>
                </div>
                <ErrorDisplay />
                <transition>
                    <keep-alive>
                        <router-view ref="view" />
                    </keep-alive>
                </transition>
            </v-container>
        </v-main>
        <Footer v-if="!isExternalFacing"></Footer>
    </v-app>
</template>

<script setup>
import Navbar from './components/navbar/Navbar.vue'
import Footer from './components/Footer.vue'
import ErrorDisplay from './components/ErrorDisplay.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'
import 'katex/dist/katex.min.css'

const store = useStore()
const showProgressLogin = computed(() => store.state.showProgressLogin)
const alertInfo = computed({
    get: () => store.state.alertInfo,
    set: (val) => store.commit('SET_ALERT_INFO', val),
})
const isExternalFacing = computed(() => store.state.isExternalFacing)
</script>

<style>
html {
    overflow-y: scroll;
    font-family: Roboto, sans-serif;
}
body,
#app {
    font-family: Roboto, sans-serif;
}
.v-main {
    padding-top: 16px;
    padding-right: 24px;
    padding-bottom: 40px;
    padding-left: 24px;
    margin-top: 64px;
}
.v-btn {
    padding-right: 32px !important;
    padding-left: 32px !important;
}

/* scrollbars */
/* width */
.styled-scrollbar::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.styled-scrollbar::-webkit-scrollbar-track {
    background: #e4e4e4;
}

/* Handle */
.styled-scrollbar::-webkit-scrollbar-thumb {
    background: #888;
}

/* Handle on hover */
.styled-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
